import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { CommonModule } from '@angular/common';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ChartType } from 'src/app/models/chart.model';

@Component({
  selector: 'vti-info-button',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './info-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoButtonComponent {
  public investmentProjectId = input<string>('');
  public type = input.required<ChartType>();

  public openModal(): void {
    switch (this.type()) {
      case 'startDate':
        this.modalTitle = this.utilitiesService.startDateTitle;
        this.modalDescription = this.utilitiesService.startDateDescription;
        break;
      case 'restored':
        this.modalTitle = this.utilitiesService.areaRestoredTitle;
        this.modalDescription = this.utilitiesService.areaRestoredDescription;
        break;
      case 'protected':
        this.modalTitle = this.utilitiesService.areaProtectedTitle;
        this.modalDescription = this.utilitiesService.areaProtectedDescription;
        break;
      case 'investment':
        this.modalTitle = this.utilitiesService.investmentTitle;
        this.modalDescription = this.utilitiesService.investmentDescription;
        break;
      case 'assets':
        this.modalTitle = this.utilitiesService.biologicalAssetsTitle;
        this.modalDescription = this.utilitiesService.biologicalAssetsDescription;
        break;
      case 'carbon':
        this.modalTitle = this.utilitiesService.carbonTitle;
        this.modalDescription = this.utilitiesService.carbonDescription;
        break;
      case 'damage':
        this.modalTitle = this.utilitiesService.damageAvoidedTitle;
        this.modalDescription = this.utilitiesService.damageAvoidedDescription;
        break;
      case 'family':
        this.modalTitle = this.utilitiesService.familiesInvolvedTitle;
        this.modalDescription = this.utilitiesService.familiesInvolvedDescription;
        break;
      case 'gains':
        this.modalTitle = this.utilitiesService.capitalGainsTitle;
        this.modalDescription = this.utilitiesService.capitalGainsDescription;
        break;
      case 'income':
        this.modalTitle = this.utilitiesService.landownersIncomeTitle;
        this.modalDescription = this.utilitiesService.landownersIncomeDescription;
        break;
      case 'money':
        this.modalTitle = this.utilitiesService.moneyDistributedTitle;
        this.modalDescription = this.utilitiesService.moneyDistributedDescription;
        break;
      case 'quality':
        this.modalTitle = this.utilitiesService.qualityHectareTitle;
        this.modalDescription = this.utilitiesService.qualityHectareDescription;
        break;
    }
    this.showModal.update(() => true);
  }

  public closeModal(): void {
    this.showModal.update(() => false);
  }

  private readonly utilitiesService = inject(UtilitiesService);

  public showModal = signal<boolean>(false);
  public modalTitle = signal<string>('');
  public modalDescription = signal<string>('');
}
